import { render, staticRenderFns } from "./Limits.vue?vue&type=template&id=3d51c4fc&scoped=true&"
import script from "./Limits.vue?vue&type=script&lang=js&"
export * from "./Limits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d51c4fc",
  null
  
)

export default component.exports